import { IItem, instanceOfIItem } from "./IItem";
import { IDateLinkApplicable } from "./IDateLinkApplicable";
import { RelationalActionParameter } from "./RelationalActionParameter";

export interface IDateLinkRequestable extends IItem {
  dateLinkDestinations: RelationalActionParameter[];
  applyDateTo(item: IDateLinkApplicable): void;
  isValueUpdated(oldItem: IItem): boolean;
}

export function instanceOfIDateLinkRequestable(instance: any): instance is IDateLinkRequestable {
  if (!instance) { return false; }
  return (instance.dateLinkDestinations !== undefined)
    && (instance.applyDateTo !== undefined)
    && (instance.isValueUpdated !== undefined)
    && instanceOfIItem(instance);
}
